import { render, staticRenderFns } from "./enquiry-status-label.vue?vue&type=template&id=1d63e192&"
import script from "./enquiry-status-label.vue?vue&type=script&lang=ts&"
export * from "./enquiry-status-label.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports